export const CalendarSVG = () => {
  return (
    <svg
      className="scale-125"
      id="calendar-icon"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 1H16V0H14V1H11V0H9V1H6V0H4V1H1C0.734784 1 0.48043 1.10536 0.292893 1.29289C0.105357 1.48043 0 1.73478 0 2V17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H19C19.2652 18 19.5196 17.8946 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17V2C20 1.73478 19.8946 1.48043 19.7071 1.29289C19.5196 1.10536 19.2652 1 19 1ZM4 3V4H6V3H9V4H11V3H14V4H16V3H18V5H2V3H4ZM2 16V7H18V16H2Z"
        fill="#3D515A"
      />
      <path d="M11 9H4V11H11V9Z" fill="#3D515A" />
      <path d="M16 12H4V14H16V12Z" fill="#3D515A" />
    </svg>
  );
};
